import { Component, Input } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxFormFieldComponent } from '../fields/checkbox-form-field/checkbox-form-field.component';
import { ToggleSwitchFormFieldComponent } from '../fields/toggle-switch-form-field/toggle-switch-form-field.component';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';
import { CommonModule } from '@angular/common';
import { UsersService } from 'app/shared/services/users.service';
import { IUser } from 'app/shared/models/users.model';
import { Subject, take, takeUntil } from 'rxjs';
import { SelectFormEnum } from 'app/shared/enums/select-form.enum';

@Component({
  selector: 'app-interested-parties-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CheckboxFormFieldComponent,
    ToggleSwitchFormFieldComponent,
    SelectFormFieldComponent,
    TranslateModule,
    CommonModule
  ],
  templateUrl: './interested-parties-form.component.html',
  styleUrl: './interested-parties-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class InterestedPartiesFormComponent {
  @Input() viewMode!: boolean;
  @Input() watchers!: boolean;

  caseClosureUsers: IUser[] = [];
  allActivityUsers: IUser[] = [];
  bookmarkOnlyUsers: IUser[] = [];
  watchersUsers: IUser[] = [];
  private destroy$ = new Subject<void>();

  form: any;

  constructor(
    public mainForm: FormGroupDirective,
    private usersService: UsersService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getUserData();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('caseClosureNotifications', new FormControl(null, []));
    this.form.addControl('allActivityUpdates', new FormControl(null, []));
    this.form.addControl('bookmarkOnly', new FormControl(null, []));
    // this.form.addControl('notifications', new FormControl(false, []));
    // this.form.addControl('notifySlaBreach', new FormControl(false, []));
    // this.form.addControl('notifyStatusChange', new FormControl(false, []));
    // this.form.addControl('notifyComments', new FormControl(false, []));
    // this.form.addControl('watchers', new FormControl(null, []));
  }

  getUserData() {
    this.usersService.users$.subscribe((users: IUser[]) => {
      this.caseClosureUsers = users;
      this.allActivityUsers = users;
      this.bookmarkOnlyUsers = users;
    });
  }

  onChange(data: any, formControlName: string) {
    if (data && data.length === 0) {
      this.form.get(formControlName).setValue(null);
    }
  }

  returnNull() {
    return null;
  }

  searchUsers(event: string, term: string, usersList: string, page: number = 0, take: number): void {
    this.usersService.getUsers(term, page * take, take)
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: IUser[]) => {
        if (event === SelectFormEnum.SCROLL) {
          (this as any)[usersList] = [...(this as any)[usersList], ...users];
        } else if (event === SelectFormEnum.SEARCH) {
          (this as any)[usersList] = [...users];
        }
      });
  }

}
